"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextField = exports.classes = void 0;
const material_1 = require("@mui/material");
const FilledInput_1 = require("@mui/material/FilledInput");
const FormLabel_1 = require("@mui/material/FormLabel");
const InputAdornment_1 = require("@mui/material/InputAdornment");
const InputBase_1 = require("@mui/material/InputBase");
const InputLabel_1 = require("@mui/material/InputLabel");
const OutlinedInput_1 = require("@mui/material/OutlinedInput");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "TextField";
exports.classes = {
    error: `${PREFIX}-error`,
    root: `${PREFIX}-root`,
    leftAdornment: `${PREFIX}-leftAdornment`,
    textFieldError: `${PREFIX}-textFieldError`,
    hybrid: `${PREFIX}-hybrid`
};
exports.StyledTextField = (0, styles_1.styled)(TextField_1.default)(({ theme }) => ({
    [`&.${exports.classes.error}`]: {
        position: "absolute",
        right: "10px"
    },
    [`.${InputLabel_1.inputLabelClasses.filled}`]: {
        lineHeight: "1.5em"
    },
    [`.${FilledInput_1.filledInputClasses.root}`]: {
        backgroundColor: theme.colours.white,
        borderRadius: "3px",
        border: `1px solid ${theme.colours.storm}`,
        "&:hover": {
            backgroundColor: theme.colours.white,
            borderColor: theme.colours.slate
        },
        "&::before": {
            content: "none"
        },
        "&::after": {
            content: "none"
        },
        "&.Mui-focused": {
            borderColor: theme.colours.inter,
            boxShadow: `inset 0 0 0 1px ${theme.colours.inter}`,
            "&.Mui-error": {
                boxShadow: `inset 0 0 0 1px ${theme.colours.error400}`
            }
        },
        "&.Mui-error": {
            borderColor: theme.colours.error400
        },
        [`.${FilledInput_1.filledInputClasses.input}`]: {
            padding: "26px 13px 9px 14px"
        },
        [`.${InputLabel_1.inputLabelClasses.filled}`]: {
            marginLeft: "2px !important"
        },
        [`.Mui-error, .Mui-error .${OutlinedInput_1.outlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.colours.error400
        },
        ".Mui-disabled": {
            opacity: 0.38,
            "&:hover": {
                borderColor: "inherit"
            }
        },
        [`.${FormLabel_1.formLabelClasses.root}`]: {
            fontSize: "16px",
            "&:not(.Mui-error):not(.Mui-disabled)": {
                color: theme.colours.slate
            },
            "&.Mui-focused:not(.Mui-error)": {
                color: theme.colours.inter
            }
        },
        [`.${InputBase_1.inputBaseClasses.inputMultiline}`]: {
            lineHeight: 1.4
        },
        [`.${FilledInput_1.filledInputClasses.inputMultiline}`]: {
            padding: 0
        }
    },
    [`&.${exports.classes.leftAdornment}`]: {
        [`.${InputLabel_1.inputLabelClasses.root}.${InputLabel_1.inputLabelClasses.shrink} ~ .${InputBase_1.inputBaseClasses.root} > .${InputAdornment_1.inputAdornmentClasses.filled}:not(.${InputAdornment_1.inputAdornmentClasses.hiddenLabel})`]: {
            marginTop: "16px",
            transition: "all 200ms cubic-bezier(0, 0, 0.2, 1) 0ms"
        },
        [`.${InputLabel_1.inputLabelClasses.root}:not(.${InputLabel_1.inputLabelClasses.shrink})`]: {
            marginLeft: "34px"
        },
        [`.${FormLabel_1.formLabelClasses.root}.${InputLabel_1.inputLabelClasses.root}`]: {
            transition: "all 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms"
        },
        [`.${InputBase_1.inputBaseClasses.root}.${InputBase_1.inputBaseClasses.formControl}.${InputBase_1.inputBaseClasses.adornedEnd}`]: {
            flexDirection: "row-reverse",
            paddingLeft: "8px",
            [`.${InputBase_1.inputBaseClasses.input}`]: {
                paddingLeft: "12px"
            },
            [`.${InputAdornment_1.inputAdornmentClasses.root}`]: {
                marginRight: 0
            }
        }
    },
    [`&.${exports.classes.textFieldError}`]: {
        [`.${InputBase_1.inputBaseClasses.input}`]: {
            paddingRight: "20px"
        }
    },
    [`.${material_1.svgIconClasses.root}`]: {
        fontSize: "16px"
    },
    [`.${InputBase_1.inputBaseClasses.root}.${OutlinedInput_1.outlinedInputClasses.root}`]: {
        paddingRight: "16px"
    },
    [`.${material_1.formHelperTextClasses.root}`]: {
        marginLeft: "2px !important",
        color: theme.colours.slate,
        "&.Mui-error": {
            color: theme.colours.error400
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,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